export const REFERENCE_PROFILE_TYPES = {
  AUTO: 'auto',
  MANUAL: 'manual',
};
